import { useEffect, useState } from "react";
import { useSettings } from "../context/SettingsContext";
import { track } from "../lib/analytics";

const KEY = "dc_consent";

function loadPixels(px) {
  if (window.__pixelsLoaded) return;
  window.__pixelsLoaded = true;
  if (px.metaPixelId) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", px.metaPixelId);
    window.fbq("track", "PageView");
  }
  if (px.tiktokPixelId) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${encodeURIComponent(px.tiktokPixelId)}&lib=ttq`;
    document.head.appendChild(s);
    window.ttq = window.ttq || { methods: [], page() {}, track() {} };
  }
  if (px.googleAdsId) {
    if (!window.gtag) {
      const g = document.createElement("script");
      g.async = true;
      g.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(px.googleAdsId)}`;
      document.head.appendChild(g);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
    }
    window.gtag("config", px.googleAdsId);
  }
}

// Consent banner: only appears when a retargeting pixel is configured and the visitor hasn't decided yet.
export default function ConsentBanner() {
  const settings = useSettings();
  const px = settings?.pixels;
  const configured = !!(px?.metaPixelId || px?.tiktokPixelId || px?.googleAdsId);
  const [decision, setDecision] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    if (configured && decision === "granted") loadPixels(px);
  }, [configured, decision, px]);

  if (!configured || decision) return null;
  const decide = (v) => { localStorage.setItem(KEY, v); setDecision(v); track("consent_" + v, {}); };

  return (
    <div data-testid="consent-banner" className="glass fixed inset-x-3 bottom-24 z-50 mx-auto max-w-xl rounded-2xl border border-white/10 bg-ink/95 p-4 shadow-2xl sm:bottom-6">
      <p className="text-sm text-white/80">We use cookies to measure which campaigns bring fans to DJ Código's music and to show you new releases on social. Music playback and analytics work either way.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid="consent-accept" onClick={() => decide("granted")} className="rounded-full bg-gold px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-black">Accept</button>
        <button data-testid="consent-decline" onClick={() => decide("denied")} className="rounded-full border border-white/20 px-5 py-2.5 text-xs font-semibold uppercase tracking-wide text-white/70">Decline</button>
        <a href="/privacy" className="ml-auto self-center text-xs text-white/40 hover:text-gold">Privacy</a>
      </div>
    </div>
  );
}
